module.exports = __webpack_public_path__ + "img/loginLogo.601d1853.png";